import { render, staticRenderFns } from "./suggestions_placeholder.vue?vue&type=template&id=0e125094"
import script from "./suggestions_placeholder.vue?vue&type=script&lang=js"
export * from "./suggestions_placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports